export default function Loading(): JSX.Element {
	return (
		<h1 style={{ fontFamily: "Roboto", fontSize: "12px" }}>Loading ...</h1>
	);
}
